import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  root: {
    fontWeight: 700,
    backgroundColor: "transparent",
    color: theme.palette.text.secondary
  },
  withoutImage: {
    borderStyle: "solid",
    borderColor: theme.palette.text.secondary
  },
  withImage: {
    border: "none"
  },
  withNameWrapper: {
    display: "flex",
    alignItems: "center",
    width: "fit-content"
  },
  withName: {
    marginRight: theme.spacing(0.5)
  },
  withChildren: {},
  withoutChildren: {
    border: "none"
  },
  smallName: {
    fontSize: theme.typography.button.fontSize
  },
  mediumName: {
    fontSize: theme.typography.body1.fontSize
  },
  largeName: {
    fontSize: theme.typography.h6.fontSize
  },
  small: {
    width: 24,
    height: 24,
    fontSize: theme.typography.button.fontSize,
    borderWidth: 1
  },
  medium: {
    width: 40,
    height: 40,
    fontSize: theme.typography.body1.fontSize,
    borderWidth: 2
  },
  large: {
    width: 55,
    height: 55,
    fontSize: theme.typography.h6.fontSize,
    borderWidth: 3
  },
  defaultsmall: {
    width: 25,
    height: 25
  },
  defaultmedium: {
    width: 40,
    height: 40
  },
  defaultlarge: {
    width: 55,
    height: 55
  },
  gutterleft: {
    marginLeft: theme.spacing(0.5)
  },
  gutterright: {
    marginRight: theme.spacing(0.5)
  },
  gutterboth: {
    margin: theme.spacing(0, 0.5)
  },
  gutternone: {
    margin: 0
  },
  hoverLink: {
    "& :hover > p, & :active > p": {
      textDecoration: "underline"
    }
  },
  alwaysLink: {
    "& p": {
      textDecoration: "underline"
    }
  }
}));
export default useStyles;